import { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Toast, ToastContainer } from 'react-bootstrap';
import api, { dedupedRequest } from '../../utils/axios';

const ProcessMapUploadPanel = ({ loadMaps }: { loadMaps: () => void }) => {
  const [svgFile, setSvgFile] = useState<File | null>(null);
  const [mapName, setMapName] = useState('');
  const [clients, setClients] = useState<{ id: number; name: string }[]>([]);
  const [selectedClientId, setSelectedClientId] = useState<string>('');
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadSuccessMessage, setUploadSuccessMessage] = useState('');
  const [uploadError, setUploadError] = useState('');


  useEffect(() => {
    dedupedRequest({ method: 'GET', url: '/admin/clients' }, { useCache: true })
      .then(res => setClients(res.data))
      .catch(err => console.error('Failed to load clients:', err));
  }, []);

  // useEffect(() => {
  //   const loadClients = async () => {
  //     try {
  //       const res = await api.get('/admin/clients');
  //       setClients(res.data);
  //     } catch (err) {
  //       console.error('Failed to load clients:', err);
  //     }
  //   };
  //   loadClients();
  // }, []);

  const handleUpload = async () => {
    if (!svgFile || !mapName || !selectedClientId) {
      alert('Please select a file, map name, and client.');
      return;
    }

    try {
      const fileText = await svgFile.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(fileText, 'text/html');

      const styleEl = doc.querySelector('style');
      const svgEl = doc.querySelector('svg');

      if (!svgEl) {
        alert('SVG not found in file.');
        return;
      }

      const styledSvg = svgEl.cloneNode(true) as SVGSVGElement;
      if (styleEl) {
        const styleTag = document.createElement('style');
        styleTag.textContent = styleEl.textContent || '';
        styledSvg.insertBefore(styleTag, styledSvg.firstChild);
      }

      const serializer = new XMLSerializer();
      const svgContent = serializer.serializeToString(styledSvg);

      await api.post('/admin/process_maps', {
        client_id: Number(selectedClientId),
        name: mapName,
        svg_content: svgContent,
      });

      setUploadSuccessMessage('Prozesskarte wurde erfolgreich hochgeladen.');
      setUploadSuccess(true);
      setUploadError('');
      setSvgFile(null);
      setMapName('');
      setSelectedClientId('');
      loadMaps(); // refresh table
    } catch (err) {
      console.error('Upload failed:', err);
      setUploadError('Upload der Prozesskarte fehlgeschlagen.');
      setUploadSuccess(false);
    }
  };

  return (
    <Form>
      <Row>
        <Col>
          <Form.Group controlId="clientSelect" className="mb-3">
            <Form.Label>Select Client</Form.Label>
            <Form.Select
              value={selectedClientId}
              onChange={(e) => setSelectedClientId(e.target.value)}
              required
            >
              <option value="">-- Choose Client --</option>
              {clients.map(client => (
                <option key={client.id} value={client.id}>
                  {client.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="mapName" className="mb-3">
            <Form.Label>Map Name</Form.Label>
            <Form.Control
              type="text"
              // placeholder="Enter process map name"
              value={mapName}
              onChange={(e) => setMapName(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
        <Col xs={7}>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Upload HTML File</Form.Label>
            <Form.Control
              type="file"
              accept=".html"
              onChange={(e) => {
                const file = (e.target as HTMLInputElement).files?.[0] || null;
                setSvgFile(file);
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Button
        variant="primary"
        onClick={handleUpload}
        disabled={!svgFile || !mapName || !selectedClientId}
      >
        Upload Map
      </Button>
      <ToastContainer position="top-end" className="p-3">
        <Toast show={uploadSuccess} onClose={() => setUploadSuccess(false)} delay={3000} autohide>
          <Toast.Header>
            <strong className="me-auto">Upload erfolgreich</strong>
          </Toast.Header>
          <Toast.Body>{uploadSuccessMessage}</Toast.Body>
        </Toast>
        <Toast show={!!uploadError} onClose={() => setUploadError('')} delay={3000} autohide>
          <Toast.Header>
            <strong className="me-auto text-danger">Upload fehlgeschlagen</strong>
          </Toast.Header>
          <Toast.Body>{uploadError}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Form>
  );
};

export default ProcessMapUploadPanel;
